import UpdateCampaignPage from "./update-campaign.page";

export default UpdateCampaignPage;
